export const commonEn: Record<string, string> = {
  // Common
  'common.error': 'Error',
  'common.new': 'New',
  'common.viewDetails': 'View Details',
  'common.add': 'Add',
  'common.notes': 'Notes',
  'common.hide': 'Hide',
  'common.print': 'Print',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.loading': 'Loading',
  'common.success': 'Success',
  'common.retry': 'Retry',
  'common.tryAgain': 'Try Again',
  'common.reloadPage': 'Reload Page',
  'common.alternative': 'Alternative',
  'common.somethingWentWrong': 'Something went wrong',
  'common.errorDetails': 'Error details',
  'common.comingSoon': 'Coming Soon',
  'common.printing': 'Printing...',
  'common.today': 'Today',
  'common.all': 'All',
  'common.appointments': 'appointments',
  'common.appointment': 'appointment',
  'common.severity.error': 'Error',
  'common.severity.warning': 'Warning',
  'common.severity.info': 'Info',
  'common.review': 'Review',
  'auth.required': 'Authentication required',
  'auth.loginRequired': 'Please log in to continue',
  'auth.page.loading': 'Loading...',
  'auth.page.heroAlt': 'Beautiful wedding ceremony moment',
  'auth.page.heroSubtitle': 'Sophisticated management for bridal boutiques',
  'auth.page.mobileSubtitle': 'Bridal CRM',
  'auth.page.welcomeTitle': 'Welcome to Sposa Suite',
  'auth.page.signInDescription': 'Sign in to your account to get started',
  'auth.page.emailLabel': 'Email',
  'auth.page.emailPlaceholder': 'Enter your email',
  'auth.page.passwordLabel': 'Password',
  'auth.page.passwordPlaceholder': 'Enter your password',
  'auth.page.signingIn': 'Signing In...',
  'auth.page.signIn': 'Sign In',
  'auth.page.signUpDisabled': 'Sign up is currently disabled. Please contact your administrator for account access.',
  'comingSoon.backToDashboard': 'Back to Dashboard',
  'comingSoon.back': 'Back',
  'comingSoon.badge': 'Coming {timeline}',
  'comingSoon.featuresAheadTitle': 'Exciting Features Ahead',
  'comingSoon.featuresAheadDescription': "We're working hard to bring you these amazing capabilities",
  'comingSoon.notifyTitle': 'Get Notified',
  'comingSoon.notifyDescription': 'Be the first to know when this feature becomes available',
  'comingSoon.notifyButton': 'Notify Me When Ready',
  'comingSoon.notifyFooter': "We'll send you an email when this feature is released",
  'comingSoon.roadmapTitle': 'Sposa Suite Roadmap:',
  'comingSoon.roadmapBody': "We're continuously improving your bridal boutique management experience. Have suggestions or specific needs? Contact our team to share your feedback.",
  'invitation.invalidTitle': 'Invalid or expired invitation',
  'invitation.invalidDescription': 'This invitation link is not valid or has expired.',
  'invitation.unknownRole': 'Unknown Role',
  'invitation.unknownOrganization': 'Unknown Organization',
  'invitation.loadError': 'Failed to load invitation details.',
  'invitation.passwordMismatchTitle': 'Password mismatch',
  'invitation.passwordMismatchDescription': 'Passwords do not match.',
  'invitation.passwordTooShortTitle': 'Password too short',
  'invitation.passwordTooShortDescription': 'Password must be at least 6 characters long.',
  'invitation.acceptErrorTitle': 'Failed to accept invitation',
  'invitation.acceptErrorDescription': 'An error occurred while accepting the invitation.',
  'invitation.accountCreatedTitle': 'Account created successfully',
  'invitation.accountCreatedDescription': 'Please sign in with your new credentials.',
  'invitation.acceptSuccessDescription': "Welcome! Your account has been created and you're now signed in.",
  'invitation.acceptRetryError': 'Failed to accept invitation. Please try again.',
  'invitation.invalidCardTitle': 'Invalid Invitation',
  'invitation.goHome': 'Go to Home',
  'invitation.acceptTitle': 'Accept Invitation',
  'invitation.invitedAs': 'You have been invited to join {organization} as a {role}.',
  'invitation.password': 'Password',
  'invitation.confirmPassword': 'Confirm Password',
  'invitation.creatingAccount': 'Creating Account...',
  'invitation.acceptAndCreate': 'Accept Invitation & Create Account',
  'admin.waitlist.fetchError': 'Failed to fetch waitlist data',
  'admin.waitlist.exportSuccess': 'Waitlist exported successfully',
  'admin.waitlist.exportError': 'Failed to export waitlist',
  'admin.waitlist.title': 'Waitlist Management',
  'admin.waitlist.subtitle': 'Early access signups and lead generation',
  'admin.waitlist.exporting': 'Exporting...',
  'admin.waitlist.exportCsv': 'Export CSV',
  'admin.waitlist.searchPlaceholder': 'Search by email, boutique, or country...',
  'admin.waitlist.filterByCountry': 'Filter by country',
  'admin.waitlist.allCountries': 'All Countries',
  'admin.waitlist.filterByPainPoint': 'Filter by pain point',
  'admin.waitlist.allPainPoints': 'All Pain Points',
  'admin.waitlist.showingEntries': 'Showing {filtered} of {total} entries',
  'admin.waitlist.matching': 'matching "{term}"',
  'admin.waitlist.stats.totalSignups': 'Total Signups',
  'admin.waitlist.stats.lastMonthGrowth': '+12% from last month',
  'admin.waitlist.stats.countries': 'Countries',
  'admin.waitlist.stats.globalReach': 'Global reach expanding',
  'admin.waitlist.stats.thisWeek': 'This Week',
  'admin.waitlist.stats.newSignups': 'New signups this week',
  'admin.waitlist.entriesTitle': 'Waitlist Entries',
  'admin.waitlist.entriesDescription': '{filtered} of {total} boutique owners waiting for early access',
  'admin.waitlist.empty.noEntries': 'No waitlist entries yet',
  'admin.waitlist.empty.noMatch': 'No entries match your filters',
  'admin.waitlist.empty.noEntriesDescription': 'Waitlist signups will appear here when users join the early access program.',
  'admin.waitlist.empty.noMatchDescription': 'Try adjusting your search terms or filters to see more results.',
  'admin.waitlist.table.boutiqueName': 'Boutique Name',
  'admin.waitlist.table.country': 'Country',
  'admin.waitlist.table.painPoint': 'Pain Point',
  'admin.waitlist.table.joinedDate': 'Joined Date',
  'admin.dashboard.title': 'Dashboard',
  'admin.dashboard.subtitle': 'Overview of all organizations and system metrics',
  'admin.dashboard.stats.totalOrganizations': 'Total Organizations',
  'admin.dashboard.stats.totalOrganizationsDescription': 'Active organizations in the system',
  'admin.dashboard.stats.activeUsers': 'Active Users',
  'admin.dashboard.stats.activeUsersDescription': 'Total active users across all orgs',
  'admin.dashboard.stats.totalLeads': 'Total Leads',
  'admin.dashboard.stats.totalLeadsDescription': 'Leads generated across all organizations',
  'admin.dashboard.stats.waitlistSignups': 'Waitlist Signups',
  'admin.dashboard.stats.waitlistSignupsDescription': 'Early access waitlist members',
  'admin.dashboard.recentActivity.title': 'Recent Activity',
  'admin.dashboard.recentActivity.description': 'Latest system activity and changes',
  'admin.dashboard.recentActivity.empty': 'No recent activity',
  'admin.dashboard.geographic.title': 'Geographic Distribution',
  'admin.dashboard.geographic.description': 'Waitlist signups by country',
  'admin.dashboard.geographic.empty': 'No geographic data available',
  'admin.dashboard.performance.title': 'System Performance',
  'admin.dashboard.performance.description': 'Real-time system metrics',
  'admin.dashboard.performance.avgResponseTime': 'Avg Response Time',
  'admin.dashboard.performance.activeConnections': 'Active Connections',
  'admin.dashboard.performance.errorRate': 'Error Rate',
  'admin.dashboard.performance.empty': 'No performance data available',
  'admin.dashboard.health.title': 'System Health',
  'admin.dashboard.health.description': 'Current system status and services',
  'admin.dashboard.health.healthy': 'Healthy',
  'admin.dashboard.health.unhealthy': 'Unhealthy',
  'admin.dashboard.health.empty': 'No health data available',
  'admin.dashboard.growth.title': 'Growth Trends',
  'admin.dashboard.growth.description': 'Monthly growth comparison',
  'admin.dashboard.growth.organizations': 'Organizations',
  'admin.dashboard.growth.waitlist': 'Waitlist',
  'admin.organizations.fetchError': 'Failed to fetch organizations: {message}',
  'admin.organizations.createSuccess': 'Organization created successfully',
  'admin.organizations.createError': 'Failed to create organization',
  'admin.organizations.updateSuccess': 'Organization updated successfully',
  'admin.organizations.updateError': 'Failed to update organization',
  'admin.organizations.bulkUpdated': 'Updated {count} organization(s)',
  'admin.organizations.bulkUpdateError': 'Failed to update organizations',
  'admin.organizations.title': 'Organizations',
  'admin.organizations.subtitle': 'Manage all organizations in the system',
  'admin.organizations.createButton': 'Create Organization',
  'admin.organizations.createDialogTitle': 'Create New Organization',
  'admin.organizations.createDialogDescription': 'Create a new organization with default settings',
  'admin.organizations.organizationName': 'Organization Name',
  'admin.organizations.organizationNamePlaceholder': 'Enter organization name',
  'admin.organizations.domainOptional': 'Domain (Optional)',
  'admin.organizations.domainPlaceholder': 'example.com',
  'admin.organizations.creating': 'Creating...',
  'admin.organizations.searchPlaceholder': 'Search organizations by name or domain...',
  'admin.organizations.filterByStatus': 'Filter by status',
  'admin.organizations.allStatus': 'All Status',
  'admin.organizations.inactive': 'Inactive',
  'admin.organizations.suspended': 'Suspended',
  'admin.organizations.bulkActions': 'Bulk Actions ({count})',
  'admin.organizations.activateSelected': 'Activate Selected',
  'admin.organizations.deactivateSelected': 'Deactivate Selected',
  'admin.organizations.suspendSelected': 'Suspend Selected',
  'admin.organizations.showing': 'Showing {filtered} of {total} organizations',
  'admin.organizations.matching': 'matching "{term}"',
  'admin.organizations.allOrganizations': 'All Organizations',
  'admin.organizations.totalDescription': '{filtered} of {total} organizations total',
  'admin.organizations.table.domain': 'Domain',
  'admin.organizations.table.status': 'Status',
  'admin.organizations.table.plan': 'Plan',
  'admin.organizations.table.users': 'Users',
  'admin.organizations.table.actions': 'Actions',
  'admin.organizations.table.activeUsers': '{count} active',
  'admin.organizations.table.leads': '{count} leads',
  'admin.organizations.editDialogTitle': 'Edit Organization',
  'admin.organizations.editDialogDescription': 'Update organization details and status',
  'admin.organizations.selectStatus': 'Select status',
  'admin.organizations.updating': 'Updating...',
  'admin.organizations.updateButton': 'Update Organization',
  'founders.title': 'Welcome to the Founding Boutique Circle!',
  'founders.subtitle': "You've secured your Founding Boutique Pass for €3,000 one-time.",
  'founders.paymentConfirmed': 'Payment Confirmed',
  'founders.confirmationSentTo': 'Confirmation sent to:',
  'founders.whatsNext': 'What Happens Next',
  'founders.next.item1': 'Watch for your detailed welcome email within 24 hours',
  'founders.next.item2': 'Gain priority access to our private Founders community',
  'founders.next.item3': 'Receive first-look product updates and exclusive previews',
  'founders.next.item4': 'Enjoy a direct feedback channel with our founding team',
  'founders.benefitsTitle': 'Your Founder Benefits',
  'founders.benefits.item1': 'Lifetime access to every current and future Sposa Suite feature',
  'founders.benefits.item2': '35% lifetime discount on the subscription, locked in forever.',
  'founders.benefits.item3': 'Priority onboarding support, 6 months of 1-on-1 guidance (valued at €20,000)',
  'founders.benefits.item4': 'Co-create new features with our product roadmap team',
  'founders.benefits.item5': 'Invite to exclusive Founder-only events and networking',
  'founders.helpText': "Questions? Ready to get started? We're here to help.",
  'founders.returnHome': 'Return to Homepage',
  'founders.memberNumber': 'Founding Member #{number}',
  'today': 'Today',
  'creating': 'Creating...',
  'create_new_appointment': 'Create New Appointment',
  'auto_save_message': 'Your progress is automatically saved',
  'back_button': 'Back',
  'budget_label': 'Budget Range',
  'choose_files': 'Choose Files',
  'complete_button': 'Complete',
  'dress_size': 'Dress Size',
  'drop_images_text': 'Drop images here or click to upload',
  'event_location': 'Event Location',
  'first_name': 'First Name',
  'image_upload_limit': 'Maximum 5 images, 5MB each',
  'images_uploaded': 'images uploaded',
  'inspiration_images': 'Inspiration Images',
  'last_name': 'Last Name',
  'maximum': 'Maximum',
  'minimum': 'Minimum',
  'name_label': 'Name',
  'next_button': 'Next',
  'partner_label': 'Partner',
  'phone_label': 'Phone',
  'profile_summary': 'Profile Summary',
  'select_dress_size': 'Select your dress size',
  'step1_title': 'Contact Information',
  'step2_title': 'Event Details',
  'step3_title': 'Dress Preferences',
  'step4_title': 'Step 4 of 4: Review & Complete',
  'success_message': 'Profile completed! Check your email for a secure sign-in link.',
  'uploading': 'Uploading...',
  'wedding_date_label': 'Wedding Date',
  'welcome_back_message': 'Welcome back! We\'ve restored your progress.',
  'filters.title': 'Filters',
  'track_alteration_tasks': 'Track alteration tasks and progress',
  'calendar.no_appointments': 'No appointments',
  'jobCentre.title': 'Job Centre',
  'jobCentre.subtitle': 'Preview of task management functionality',
  'jobCentre.permissions.noAccess': "You don't have permission to view tasks.",
  'jobCentre.permissions.contactAdmin': 'Please contact your administrator to request access.',
  'jobCentre.actions.snoozeSelected': 'Snooze Selected',
  'jobCentre.actions.completeSelected': 'Complete Selected',
  'jobCentre.tabs.all': 'All Tasks',
  'jobCentre.tabs.leads': 'Leads',
  'jobCentre.tabs.customers': 'Customers',
  'jobCentre.loadingTasks': 'Loading tasks...',
  'jobCentre.empty.all.title': 'No tasks found',
  'jobCentre.empty.all.description': 'There are no tasks matching your current filters.',
  'jobCentre.empty.leads.title': 'No lead tasks found',
  'jobCentre.empty.leads.description': 'There are no lead-related tasks at the moment.',
  'jobCentre.empty.customers.title': 'No customer tasks found',
  'jobCentre.empty.customers.description': 'There are no customer-related tasks at the moment.',
  'jobCentre.groups.overdue': 'Overdue',
  'jobCentre.groups.upcoming': 'Upcoming',
  'jobCentre.assignee.unassigned': 'Unassigned',
  'jobCentre.assignee.placeholder': 'Assign...',
  'jobCentre.entity.unknown': 'Unknown',
  'jobCentre.entity.lead': 'Lead',
  'jobCentre.entity.customer': 'Customer',
  'jobCentre.badge.demo': 'DEMO',
  'jobCentre.toast.demoTaskUpdated.title': 'Demo Task Updated',
  'jobCentre.toast.demoTaskUpdated.description': 'Assignee changed to {assigneeName}. This is a demo - real functionality coming soon!',
  'jobCentre.toast.demoTask.title': 'Demo Task',
  'jobCentre.toast.demoTask.description': 'This is a demo task. Task management will be available when connected to your data.',
  'jobCentre.toast.demoTask.fullDetailsDescription': 'Full task details will be available when connected to your data.',
  'jobCentre.toast.demoTasks.title': 'Demo Tasks',
  'jobCentre.toast.demoTasks.description': 'These are demo tasks. Task management will be available when connected to your data.',
  'jobCentre.toast.tasksCompleted': '{count} tasks marked as completed',
  'jobCentre.toast.completeError': 'Failed to complete tasks. Please try again.',
  'jobCentre.toast.tasksSnoozed': '{count} tasks snoozed until tomorrow',
  'jobCentre.toast.snoozeError': 'Failed to snooze tasks. Please try again.',
  'jobCentre.toast.featureComingSoon.title': 'Feature Coming Soon',
  'jobCentre.toast.featureComingSoon.assigneeDescription': 'Real task assignee changes will be available when connected to your data.',
  'jobCentre.demoTasks.followUp.title': 'Follow up with wedding inquiry',
  'jobCentre.demoTasks.followUp.description': 'Initial consultation completed, need to send dress options and pricing',
  'jobCentre.demoTasks.firstFitting.title': 'Schedule first fitting appointment',
  'jobCentre.demoTasks.firstFitting.description': 'Customer has selected dress, need to book fitting appointment',
  'jobCentre.demoTasks.careInstructions.title': 'Send dress care instructions',
  'jobCentre.demoTasks.careInstructions.description': 'Final dress pickup completed, send care and storage instructions',
  'jobCentre.demoTasks.depositPayment.title': 'Process deposit payment',
  'jobCentre.demoTasks.depositPayment.description': 'Customer ready to place order, collect deposit and create contract',
  'jobCentre.demoTasks.finalAlterations.title': 'Final dress alterations',
  'jobCentre.demoTasks.finalAlterations.description': 'Complete final alterations before wedding date',
  'jobCentre.demoTasks.consultationCall.title': 'Wedding consultation call',
  'jobCentre.demoTasks.consultationCall.description': 'Initial consultation to discuss requirements and show dress collection',
  'legal.lastUpdated.july2025': 'July 2025',
  'legal.privacy.title': 'Sposa Suite - Privacy Policy',
  'legal.privacy.section1.title': '1. Introduction',
  'legal.privacy.section1.body': 'Sposa Suite ("we," "us," "our") is a comprehensive boutique-business operating system that manages customers, leads, communications, products, orders, finances, suppliers, engagement with brides, reports and more-all in one place. This Privacy Policy explains how Momentum Group s. r. o. ("Company") collects, uses, and protects your data when you use Sposa Suite.',
  'legal.privacy.section2.title': '2. Data We Collect',
  'legal.privacy.section2.companyAccount.label': 'Company Account Data:',
  'legal.privacy.section2.companyAccount.body': 'Salon name, ICO/VAT, address, contact email/phone.',
  'legal.privacy.section2.userData.label': 'User Data:',
  'legal.privacy.section2.userData.body': 'Names, emails, phone numbers, roles and permissions.',
  'legal.privacy.section2.brideLead.label': 'Bride & Lead Data:',
  'legal.privacy.section2.brideLead.body': 'Contact details, event dates/venues, measurement photos, fitting photos, wishlist items, appointment history, portal activity.',
  'legal.privacy.section2.operational.label': 'Operational Data:',
  'legal.privacy.section2.operational.body': 'Products, inventory levels, supplier contacts, order details, invoices, payments.',
  'legal.privacy.section2.analytics.label': 'Usage & Analytics:',
  'legal.privacy.section2.analytics.body': 'IP address, device/browser info, pages and features used, timestamps.',
  'legal.privacy.section2.communications.label': 'Communications & Support:',
  'legal.privacy.section2.communications.body': 'Messages and chat logs between agents, consultants, and brides (via WhatsApp, Messenger, Instagram, SMS, email).',
  'legal.privacy.section2.payment.label': 'Payment Data:',
  'legal.privacy.section2.payment.body': 'Transaction IDs, invoice records-actual card/payment data handled by Stripe.',
  'legal.privacy.section3.title': '3. How We Use Your Data',
  'legal.privacy.section3.serviceOperation.label': 'Service Operation:',
  'legal.privacy.section3.serviceOperation.body': 'Power all modules-lead management, customer portal, product catalog, orders, invoicing, supplier tracking, reporting.',
  'legal.privacy.section3.communications.label': 'Communications:',
  'legal.privacy.section3.communications.body': 'Send confirmations, reminders, support messages, and portal updates.',
  'legal.privacy.section3.analytics.label': 'Analytics & Improvement:',
  'legal.privacy.section3.analytics.body': 'Analyze usage to refine features, measure performance, and train our 24/7 agent team.',
  'legal.privacy.section3.legalCompliance.label': 'Legal & Compliance:',
  'legal.privacy.section3.legalCompliance.body': 'Fraud prevention, tax reporting, GDPR/CCPA compliance.',
  'legal.privacy.section4.title': '4. Cookies & Tracking',
  'legal.privacy.section4.body': 'We set essential cookies for authentication and performance cookies (analytics/error-tracking). You can manage consent via the cookie banner.',
  'legal.privacy.section5.title': '5. Data Sharing',
  'legal.privacy.section5.intro': 'We share information only with:',
  'legal.privacy.section5.providers.label': 'Service Providers:',
  'legal.privacy.section5.providers.body': 'Stripe, Google Calendar, WhatsApp API, Meta Business-under strict data-processing agreements.',
  'legal.privacy.section5.staff.label': 'Salon Staff:',
  'legal.privacy.section5.staff.body': 'Assigned users within your organisation.',
  'legal.privacy.section5.authorities.label': 'Legal Authorities:',
  'legal.privacy.section5.authorities.body': 'If required by law.',
  'legal.privacy.section6.title': '6. Payments & Billing',
  'legal.privacy.section6.body': 'All financial transactions process through Stripe; we never store full payment credentials. You can view invoices and payment history in your Back-Office Hub.',
  'legal.privacy.section7.title': '7. Data Retention & Deletion',
  'legal.privacy.section7.bodyPrefix': 'We retain data while your account is active or as required by law. You may request export or deletion of your data by contacting',
  'legal.privacy.section7.bodySuffix': '.',
  'legal.privacy.section8.title': '8. Security',
  'legal.privacy.section8.bodyPrefix': 'We use TLS 1.3 encryption in transit, AES 256-bit at rest, role-based access, and regular security audits. Report any suspicious activity to',
  'legal.privacy.section8.bodySuffix': '.',
  'legal.privacy.section9.title': '9. Your Rights',
  'legal.privacy.section9.bodyPrefix': 'Under GDPR and similar laws, you have rights to access, correct, port, or delete your personal data. Contact',
  'legal.privacy.section9.bodySuffix': 'to exercise these rights.',
  'legal.privacy.section10.title': '10. Changes to This Policy',
  'legal.privacy.section10.body': 'We may update this policy; changes take effect upon posting here. Continued use implies acceptance.',
  'legal.terms.title': 'Sposa Suite - Terms of Service',
  'legal.terms.section1.title': '1. Agreement',
  'legal.terms.section1.body': 'These Terms govern your use of Sposa Suite, the all-in-one boutique-business system. By accessing or using the Service, you agree to these Terms and our Privacy Policy.',
  'legal.terms.section2.title': '2. Accounts & Access',
  'legal.terms.section2.eligibility.label': 'Eligibility:',
  'legal.terms.section2.eligibility.body': 'You must be authorised by your salon to act on its behalf.',
  'legal.terms.section2.credentials.label': 'Credentials:',
  'legal.terms.section2.credentials.body': 'Keep login details secure. You are responsible for all activity under your account.',
  'legal.terms.section2.roles.label': 'Roles & Permissions:',
  'legal.terms.section2.roles.body': 'Salon Admins configure user roles, access levels, and menu visibility in Settings.',
  'legal.terms.section3.title': '3. Subscription & Fees',
  'legal.terms.section3.suitePlan.label': 'Suite Plan:',
  'legal.terms.section3.suitePlan.body': 'Flat fee covers Bridal Portal, Back-Office Hub, and basic 24/7 agent support.',
  'legal.terms.section3.seatsAddons.label': 'Seats & Add-Ons:',
  'legal.terms.section3.seatsAddons.body': 'Additional staff seats and premium services billed separately.',
  'legal.terms.section3.paymentTerms.label': 'Payment Terms:',
  'legal.terms.section3.paymentTerms.body': "Recurring billing via Stripe. Cancel with two months' notice; no refunds for partial periods.",
  'legal.terms.section4.title': '4. Onboarding & Professional Services',
  'legal.terms.section4.launchPackage.label': 'Launch Package:',
  'legal.terms.section4.launchPackage.body': 'Optional 8-week engagement (EUR 20 000) for process mapping, configuration, data migration and training.',
  'legal.terms.section4.scopeChanges.label': 'Scope Changes:',
  'legal.terms.section4.scopeChanges.body': 'Any work beyond the defined phases is billable at our standard consulting rate.',
  'legal.terms.section5.title': '5. Acceptable Use',
  'legal.terms.section5.intro': 'You may not:',
  'legal.terms.section5.item1': 'Reverse-engineer, scrape, or disrupt the Service.',
  'legal.terms.section5.item2': 'Use Sposa Suite for unlawful activities or to send unsolicited marketing.',
  'legal.terms.section5.item3': 'Distribute malware or compromise system integrity.',
  'legal.terms.section6.title': '6. Intellectual Property',
  'legal.terms.section6.body': 'All software, content, and trademarks belong to Momentum Group s. r. o. or licensors. You receive a limited licence to use the Service per these Terms.',
  'legal.terms.section7.title': '7. Confidentiality',
  'legal.terms.section7.body': "Both parties will protect each other's confidential information and not disclose it except as required by law.",
  'legal.terms.section8.title': '8. Warranties & Disclaimers',
  'legal.terms.section8.body': 'We aim for high availability but offer the Service "as-is." We disclaim all implied warranties, including merchantability and fitness for a particular purpose.',
  'legal.terms.section9.title': '9. Limitation of Liability',
  'legal.terms.section9.body': 'Our liability is capped at the total subscription fees you paid in the prior 12 months. We are not liable for indirect or consequential damages.',
  'legal.terms.section10.title': '10. Termination',
  'legal.terms.section10.byYou.label': 'By You:',
  'legal.terms.section10.byYou.body': "You may cancel with two months' notice; data handled per retention policy.",
  'legal.terms.section10.byUs.label': 'By Us:',
  'legal.terms.section10.byUs.body': 'We may suspend or terminate accounts for non-payment, breach of these Terms, or illegal use.',
  'legal.terms.section11.title': '11. Governing Law',
  'legal.terms.section11.body': 'These Terms are governed by Slovak law, and disputes are resolved in Bratislava courts.',
  'legal.terms.section12.title': '12. Changes to Terms',
  'legal.terms.section12.body': 'We will notify you of updates 30 days before they take effect. Continued use implies acceptance.',

  // Error Boundaries
  'errorBoundary.productError': 'An error occurred while loading the products. This might be a temporary issue.',
  'errorBoundary.generalError': 'An unexpected error occurred. Please try refreshing the page.',

  // Time units
  'day': 'day',
  'days': 'days',
  'hour': 'hour',
  'hours': 'hours',
  'minute': 'minute',
  'minutes': 'minutes',
  'second': 'second',
  'seconds': 'seconds',
  'countdown_sr_days': 'days',
  'countdown_sr_hours': 'hours',
  'countdown_sr_minutes': 'minutes',
  'countdown_sr_seconds': 'seconds',
  'countdown_sr_until': 'until your wedding',

  // General labels used across the app
  'loading': 'Loading...',
  'coming_soon': 'Soon',
  'soon': 'Soon',
  'success': 'Success',
  'error': 'Error',
  'cancel': 'Cancel',
  'edit': 'Edit',
  'delete': 'Delete',
  'new': 'New',
  'all': 'All',
  'other': 'Other',
  'category': 'Category',
  'size': 'Size',
  'color': 'Color',
  'brand': 'Brand',
  'colour': 'Colour',
  'details': 'Details',
  'history': 'History',
  'overview': 'Overview',
  'timeline': 'Timeline',
  'preview': 'Preview',
  'share': 'Share',
  'upload': 'Upload',
  'added': 'Added',
  'active': 'Active',
  'completed': 'Completed',
  'pending': 'Pending',
  'redeemed': 'Redeemed',
  'qty': 'Qty',
  'total': 'Total €',
  'more': 'more',
  'view_details': 'View Details',
  'view_profile': 'View profile',
  'not_provided': 'Not provided',

  // Document language selection
  'documents.selectLanguage': 'Select language',
  'documents.languageHelp': 'Choose the language for this document',

  // Database Field Labels
  'field_first_name': 'First Name',
  'field_last_name': 'Last Name',
  'field_email': 'Email',
  'field_phone': 'Phone',
  'field_wedding_date': 'Wedding Date',
  'field_partner_name': 'Partner Name',
  'field_order_no': 'Order #',
  'field_total_amount': 'Total Amount',
  'field_balance': 'Balance',
  'field_due_date': 'Due Date',
  'field_delivery_date': 'Delivery Date',
  'field_task_name': 'Task Name',
  'field_task_type': 'Task Type',
  'field_assignee': 'Assignee',
  'field_created_at': 'Created',
  'field_updated_at': 'Updated',
  'field_notes': 'Notes',
  'field_title': 'Title',
  'field_organization_id': 'Organization',
  'field_customer_id': 'Customer',
  'field_user_id': 'User',
  'field_stage_id': 'Stage',
  'field_version': 'Version',
  'field_measured_by': 'Measured By',
  'field_photo_url': 'Photo',
  'field_contact_first_name': 'First Name',
  'field_contact_last_name': 'Last Name',
  'field_contact_email': 'Email',
  'field_contact_phone': 'Phone',

  // Status Values
  'status_draft': 'Draft',
  'status_open': 'Open',
  'status_confirmed': 'Confirmed',
  'status_in_progress': 'In Progress',
  'status_completed': 'Completed',
  'status_cancelled': 'Cancelled',
  'status_archived': 'Archived',
  'status_pending': 'Pending',
  'status_on_hold': 'On Hold',
  'status_new': 'New',
  'status_contacted': 'Contacted',
  'status_qualified': 'Qualified',
  'status_proposal_sent': 'Proposal Sent',
  'status_won': 'Won',
  'status_lost': 'Lost',
  'status_redeemed': 'Redeemed',

  // Alteration Status
  'alteration_pending': 'Pending',
  'alteration_in_progress': 'In Progress',
  'alteration_completed': 'Completed',
  'alteration_on_hold': 'On Hold',

  // Appointment Types
  'appointment_consultation': 'Consultation',
  'appointment_fitting': 'Fitting',
  'appointment_final_fitting': 'Final Fitting',
  'appointment_alteration': 'Alteration',

  // Conditional Displays
  'overdue_status': '(Overdue)',
  'no_assignee': 'Unassigned',
  'no_data': '-',
  'select_assignee': 'Select assignee',
  'no_stage_set': 'No stage set',
  'no_customer_set': 'No customer',
  'unknown_status': 'Unknown',

  // Measurement Fields
  'field_bust': 'Bust',
  'field_waist': 'Waist',
  'field_hips': 'Hips',
  'field_height': 'Height',
  'field_shoulder': 'Shoulder',
  'field_arm_circumference': 'Arm Circumference',
  'field_bust_circumference': 'Bust Circumference',
  'field_waist_circumference': 'Waist Circumference',
  'field_hip_circumference': 'Hip Circumference',
  'field_chest_circumference': 'Chest Circumference',
  'field_abdomen_circumference': 'Abdomen Circumference',
  'field_wrist_circumference': 'Wrist Circumference',
  'field_bust_height': 'Bust Height',
  'field_distance_between_breasts': 'Distance Between Breasts',
  'field_shoulder_width_back': 'Shoulder Width Back',
  'field_waist_length_back': 'Waist Length Back',
  'field_waist_length_front': 'Waist Length Front',
  'field_sleeve_length': 'Sleeve Length',
  'field_skirt_length': 'Skirt Length',
  'field_hip_upper': 'Hip Upper',

  // Payment Method Types
  'payment_cash': 'Cash',
  'payment_card': 'Card',
  'payment_bank_transfer': 'Bank Transfer',
  'payment_other': 'Other',

  // Table Headers
  'table_name': 'Name',
  'table_contact': 'Contact',
  'table_partner': 'Partner',
  'table_portal_status': 'Portal Status',
  'table_created': 'Created',
  'table_customer_name': 'Customer Name',
  'table_order_number': 'Order Number',
  'table_task_title': 'Task',
  'table_priority': 'Priority',
  'table_stage': 'Stage',
  'table_due_date': 'Due Date',
  'table_type': 'Type',
  'table_measurement_version': 'Version',
  'table_measurement_date': 'Date',
  'table_measured_by': 'Measured By',

  // Communication Channels
  'channel_email': 'Email',
  'channel_phone': 'Phone',
  'channel_sms': 'SMS',
  'channel_whatsapp': 'WhatsApp',
  'channel_instagram': 'Instagram',
  'channel_facebook': 'Facebook',

  // Shared source keys
  'sources.website': 'Website',
  'sources.instagram': 'Instagram',
  'sources.facebook': 'Facebook',
  'sources.referral': 'Referral',
  'sources.walkIn': 'Walk-in',
  'sources.venue': 'Venue',
  'sources.Form': 'Form',
  'sources.manual': 'Manual',
  'sources.unknown': 'Unknown',
  'sources.other': 'Other',

  // Field names
  'fields.email': 'Email',
  'fields.firstName': 'First Name',
  'fields.lastName': 'Last Name',
  'fields.phone': 'Phone',
  'fields.budgetMin': 'Budget Min',
  'fields.budgetMax': 'Budget Max',
  'fields.eventDate': 'Event Date',
  'fields.eventLocation': 'Event Location',
  'fields.partnerName': 'Partner Name',
  'fields.source': 'Source',
  'fields.notes': 'Notes',
  'fields.howDidYouHear': 'How Did You Hear',
  'fields.dreamWeddingDescription': 'Dream Wedding Description',
  'fields.specialRequests': 'Special Requests',
  'fields.guestCount': 'Guest Count',
  'fields.ceremony': 'Ceremony',
  'fields.reception': 'Reception',
  'fields.honeymoon': 'Honeymoon',
  'fields.dressSize': 'Dress Size',
  'fields.dressStyle': 'Dress Style',
  'fields.shoeSize': 'Shoe Size',
  'fields.hasChildren': 'Has Children',
  'fields.address': 'Address',
  'fields.city': 'City',
  'fields.country': 'Country',
  'fields.customField1': 'Custom Field 1',
  'fields.customField2': 'Custom Field 2',
  'fields.customField3': 'Custom Field 3',
  'fields.customField4': 'Custom Field 4',
  'fields.customField5': 'Custom Field 5',

  // Pagination
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',
  'pagination.goPrevious': 'Go to previous page',
  'pagination.goNext': 'Go to next page',
  'pagination.morePages': 'More pages',
  'pagination.showing': 'Showing {from}-{to} of {total}',

  // Validation
  'validation.mustBeFixed': 'must be fixed before saving',
  'validation.canBeSavedWith': 'The appointment can be saved with',
  'validation.workBreak': 'Cannot schedule during work break ({breakTime})',
  'validation.workBreakGeneric': 'Cannot schedule during work break',
  'validation.warning': 'warning',
  'validation.warnings': 'warnings',
  'validation.field.title': 'Title',
  'validation.field.customer_id': 'Customer',
  'validation.field.type': 'Type',
  'validation.field.start_time': 'Start Time',
  'validation.field.end_time': 'End Time',
  'validation.field.location': 'Location',
  'validation.field.description': 'Description',
  'validation.field.staff_id': 'Staff',
  'validation.field.fitting_room_id': 'Fitting Room',

  // Shared action labels
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.unsaved': 'Unsaved',

  // Access Denied
  'accessDenied.title': 'Access Denied',
  'accessDenied.description': 'You don\'t have permission to view this page. Contact your administrator to request access.',
  'accessDenied.goToDashboard': 'Go to Dashboard',
};
